// Documentary-quality imagery (native bush, sunrise, wāhine, harakeke, aerial forest)
export const IMAGES = {
  heroForest:
    "https://images.unsplash.com/photo-1598635017899-3f6d1ec1e1f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxOZXclMjBaZWFsYW5kJTIwbmF0aXZlJTIwZm9yZXN0JTIwbWlzdCUyMHN1bnJpc2V8ZW58MHx8fHwxNzgzNTk2ODgxfDA&ixlib=rb-4.1.0&q=85",
  wahineGolden:
    "https://images.unsplash.com/photo-1762222378422-f0e3a236bc4a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHx3b21hbiUyMHBvcnRyYWl0JTIwZ29sZGVuJTIwaG91ciUyMG5hdHVyZXxlbnwwfHx8fDE3ODM1OTY5MDJ8MA&ixlib=rb-4.1.0&q=85",
  founder:
    "https://customer-assets.emergentagent.com/job_wahine-mana/artifacts/92tgu9d1_CEO%20Founder%20of%20nga%20kakano.png",
  documentary:
    "https://images.unsplash.com/photo-1667382268488-8ee9396b080a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBkb2N1bWVudGFyeSUyMHBob3RvZ3JhcGh5JTIwcGVvcGxlfGVufDB8fHx8MTc4MzU5Njg4MXww&ixlib=rb-4.1.0&q=85",
  rootsTexture:
    "https://images.unsplash.com/photo-1486126040654-f809583dfba3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMHRyZWUlMjByb290cyUyMGVhcnRoJTIwdGV4dHVyZXxlbnwwfHx8fDE3ODM1OTY4ODF8MA&ixlib=rb-4.1.0&q=85",
  mistMountains:
    "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?auto=format&fit=crop&w=1920&q=80",
  forestSun:
    "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=1920&q=80",
  aerialForest:
    "https://images.unsplash.com/photo-1511497584788-876760111969?auto=format&fit=crop&w=1920&q=80",
  forestPath:
    "https://images.unsplash.com/photo-1447752875215-b2761acb3c5d?auto=format&fit=crop&w=1600&q=80",
  fernLight:
    "https://images.unsplash.com/photo-1518495973542-4542c06a5843?auto=format&fit=crop&w=1600&q=80",
};

export const SEED_STAGES = [
  { label: "A Seed", detail: "Where every story begins." },
  { label: "Education", detail: "Knowledge takes root." },
  { label: "Experience", detail: "Learning by doing." },
  { label: "Confidence", detail: "Believing in what's possible." },
  { label: "Business", detail: "An idea becomes an enterprise." },
  { label: "Leadership", detail: "Standing tall, guiding others." },
  { label: "Employment", detail: "Creating work, not seeking it." },
  { label: "Whānau", detail: "Prosperity that comes home." },
  { label: "Community", detail: "A rising tide for all." },
  { label: "Generations", detail: "A forest that outlives us." },
];

export const JOURNEY_STAGES = [
  { title: "Discovery", body: "We intend to meet wāhine where they are — with dignity, curiosity, and the belief that potential is already present." },
  { title: "Application", body: "A first commitment. The moment a seed decides to grow." },
  { title: "Level 3 Business", body: "Foundational business study designed to build real, transferable capability." },
  { title: "Volunteer Experience", body: "Hands-on experience in live enterprise — learning the rhythm of business." },
  { title: "Leadership", body: "Discovering the leader within, and the responsibility that comes with it." },
  { title: "Level 4", body: "Advanced study intended to deepen strategy, finance, and operations knowledge." },
  { title: "Business Accelerator", body: "Structured support to shape a viable, fundable business concept." },
  { title: "Micro Startup Pilot", body: "A protected first launch — testing the model with real customers." },
  { title: "Business Launch", body: "The enterprise opens its doors. An owner is born." },
  { title: "Graduate", body: "From participant to proprietor. A journey that changes a life." },
  { title: "Mentor", body: "Turning around to guide the next wāhine up the path." },
  { title: "Leader", body: "Building businesses that build businesses — and generations." },
];

// --- How It Works page data ---
export const HOW_JOURNEY = [
  "AKO — Learn",
  "MAHI — Experience",
  "WHAKAARO — Develop",
  "PILOT — Test",
  "PAKIHI — Build",
];

export const MILESTONES = [
  "Business registration",
  "Branding",
  "Packaging",
  "Equipment",
  "Marketing",
  "Website",
  "Mentoring",
  "Customer access",
];

export const KAUPAPA_VALUES = [
  { reo: "Rangatiratanga", en: "Leadership & self-determination" },
  { reo: "Partnership", en: "Walking together as equals" },
  { reo: "Active Protection", en: "Protecting the kaupapa and its people" },
  { reo: "Participation", en: "Everyone has a place at the table" },
  { reo: "Manaakitanga", en: "Care, generosity and respect" },
  { reo: "Whanaungatanga", en: "Relationships and belonging" },
  { reo: "Kaitiakitanga", en: "Guardianship of people and whenua" },
  { reo: "Pono", en: "Honesty and truth" },
  { reo: "Tika", en: "Doing what is right" },
  { reo: "Aroha", en: "Love and compassion" },
];


export const ECOSYSTEM = [
  { name: "Koro Holdings", role: "Te pūtake — the foundation. Capital and stewardship held with care." },
  { name: "Ngā Kākano Holdings", role: "Where opportunity is cultivated and directed." },
  { name: "Ngā Kākano Wāhine", role: "Te manawa — the heart. Guiding wāhine back into their mana." },
  { name: "Ngahere Development Trust", role: "Te ngahere — the forest. Community, legacy, and generations." },
];

export const VALUES = [
  { title: "Potential", body: "We begin with what is possible, never what is broken." },
  { title: "Mana", body: "Dignity restored, standing reclaimed." },
  { title: "Leadership", body: "Every wāhine a leader in the making." },
  { title: "Whānau", body: "Success that comes home to family." },
  { title: "Integrity", body: "We do what we say, with aroha." },
  { title: "Enterprise", body: "Business as the vehicle for freedom." },
  { title: "Service", body: "Lifting as we climb." },
  { title: "Legacy", body: "Planting forests we may never sit beneath." },
];

export const WHY_STATS = [
  {
    value: "64%",
    label: "of women in prison in Aotearoa are Māori (2024).",
    why: "Up from 62% in 2014. 75% of the March 2024 women's remand population were Māori. — NZ Dept of Corrections.",
  },
  {
    value: "45%",
    label: "of the NZ prison population is now held on remand.",
    why: "Up from ~20% in 2014. — Corrections, Strategic Intentions 2025–2029.",
  },
  {
    value: "20.0%",
    label: "Māori women's underutilisation rate, March 2025.",
    why: "Employment rate ~59.1% for Māori women, vs 67.6% overall. — MBIE, Māori Labour Market Statistics.",
  },
  {
    value: "1.5×",
    label: "Pacific peoples are at least 1.5× more likely to work in low-skilled labouring roles.",
    why: "MBIE also identified ~4,100 self-employed Pacific people. — MBIE, Pacific & Māori Economic Development.",
  },
];

export const STATS = [
  { value: 63, suffix: "%", label: "of incarcerated wāhine are Māori — carrying stories the system never saw." },
  { value: 80, suffix: "%", label: "of children with an imprisoned parent face intergenerational disadvantage." },
  { value: 1, prefix: "$", suffix: "B+", label: "in lost potential each year — talent that was never given a pathway." },
];
